// Copyright (c) Move Closer 2022.
import { SetupPlugins } from '@/shared/core/src/front/shared/plugins/uvue/setup'

export default SetupPlugins
